
import { defineComponent, ref } from "vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import {
  getSamplingPointNames,
  getSamPointOnlyParameters,
  samPointOnlyParametersClient,
} from "@/service/samplingpoint.service";
import { Parameter } from "@/types/parameter.type";
import { getParameterClient } from "@/service/parameter.service";
import { FormInstance, ElForm } from "element-plus";
import { Filter } from "@/types/filter.type";
import { GraphClientFilter } from "@/types/graphClient";
import { getDatesWithDataClient } from "@/service/graphClient.service";

export default defineComponent({
  props: {
    checked: { type: Boolean },
  },
  setup() {
    const ruleFormRef = ref<FormInstance>();

    return { ruleFormRef };
  },
  data() {
    return {
      graphClientFilter: {} as GraphClientFilter, //- Obj. del formulario
      parameters: [] as Parameter[], // - Lista de parámetros del sistema
      parametersClient: [] as Parameter[], // - Lista de parámetros del sistema
      samplingPoint: [] as SamplingPoint[], // - Lista de puntos de monitorizacion
      datesWithEstimations: [] as string[],
      datesWithClient: [] as string[],
      changeFilter: false as boolean,
      //disableDate: true as boolean,
      // placeholderParams: "Selecionar" as string,
      // inputDesavilidato: false as boolean,
      rules: {
        samplingPoint: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        dataFile: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        parameter: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        parameterClient: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        startDate: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$t("error.required"),
            trigger: blur,
          },
        ],
      },
    };
  },
  async mounted() {
    this.samplingPoint = await getSamplingPointNames();
    let filterClient: Filter = {
      fields: {
        "parameter.active": { operator: "equal", value: true },
        "parameter.client": { operator: "equal", value: true },
      },
      multi: undefined,
    };
    this.parametersClient = (await getParameterClient(undefined, undefined, filterClient)).data;

    //- Si accedemos a "Servicio de graficación" desde importar
    this.$emit("graphData", this.graphClientFilter);
    if (this.$route.query.samplingPointId) {
      this.parameters = await getSamPointOnlyParameters(Number(this.$route.query.samplingPointId));
      this.daysThereAreDateClient();
    }
    this.changeFilter = false;
  },
  methods: {
    /**
     * Obtener las estimaciones que tenemos del parámetro subido por el cliente para marcarlo en los datapickers.
     */
    async daysThereAreDateClient() {
      const samplingpoint = this.$route.query.samplingPointId
        ? Number(this.$route.query.samplingPointId)
        : this.graphClientFilter.samplingPoint?.id;
      const parameter = this.$route.query.parameterId
        ? Number(this.$route.query.parameterId)
        : this.graphClientFilter.parameterClient?.id;

      if (samplingpoint && parameter) {
        await getDatesWithDataClient(samplingpoint, parameter).then((response) => {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this.datesWithClient = response.map((_: any) =>
            new Date(_.clientData_dateTime).toDateString()
          );
        });
        this.changeFilter = true;
      }
    },
    /**
     * Deshabilitar en los datepickers las fechas futuras
     */
    futureDay(date: Date) {
      return date.getTime() > Date.now();
    },
    disabledDataClient(date: Date) {
      this.changeFilter = true;
      if (!this.datesWithClient.includes(date.toDateString())) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Recuperar los parámetros según el punto de monitorización seleccionado
     */
    async putParameter() {
      if (
        this.graphClientFilter.samplingPoint &&
        this.graphClientFilter.samplingPoint?.id !== undefined
      ) {
        let parameterClientSelect = await samPointOnlyParametersClient(
          this.graphClientFilter.samplingPoint?.id
        );
        let parameterClient = parameterClientSelect.filter((item) => {
          return item.client ? item : "";
        });
        this.parametersClient = parameterClient;

        let parameterSelect = await getSamPointOnlyParameters(
          this.graphClientFilter.samplingPoint?.id
        );
        let parameter = parameterSelect.filter((item) => {
          return item.active ? item : "";
        });
        this.parameters = parameter;
        this.changeFilter = true;
      }
    },
    async postDataFilter() {
      this.changeFilter = false;
      return { graphClientFilter: this.graphClientFilter };
    },
    async valdidate() {
      let valid;
      valid = await (this.$refs["ruleFormRef"] as InstanceType<typeof ElForm>).validate();
      if (!valid) {
        throw new Error("validation");
      }
      return true;
    },

    hasEstimatedData(day: Date) {
      return this.datesWithEstimations.includes(day.toDateString());
    },
    checkFilterChange() {
      return this.changeFilter;
    },
  },
});
